(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('manageExaminerPanel', manageExaminerPanel);

    function manageExaminerPanel() {
        return {
            templateUrl: '/app/directives/manage-examiner-panel.tpl.html',
            scope: {
                activity: '=',
                examiners: '='
            },
            controller: ManageExaminerPanelController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ManageExaminerPanelController($scope, $window, logger, modalDialogService) {
        var vm = this;

        vm.addExaminers = addExaminers;
        vm.removeExaminer = removeExaminer;

        function addExaminers() {
            return modalDialogService.openAddExaminersDialog(vm.activity).then(examiners => {
                vm.examiners = vm.examiners || [];
                for (var i = 0; i < examiners.length; i++) {
                    if (_.find(vm.examiners, { idString: examiners[i].idString }) === undefined) {
                        vm.examiners.push(examiners[i]);
                    }
                }
            });
        }

        function removeExaminer(identity) {
            var idx = vm.examiners.indexOf(identity);
            vm.examiners.splice(idx, 1);
        }
    }
})();